<div class="sq-content">
  <h1>{{'info.title' | translate}}</h1>
  <h2>{{'info.contact.title' | translate}}</h2>
  <span [innerHTML]="'info.contact.text' | translate | safeHtml"></span>
  <h2>{{'info.tc_dp.title' | translate}}</h2>
  <span [innerHTML]="'info.tc_dp.text' | translate"></span>
</div>
